import { render, staticRenderFns } from "./LongTrendGraph.vue?vue&type=template&id=512ddd6a&scoped=true&"
import script from "./LongTrendGraph.vue?vue&type=script&lang=ts&"
export * from "./LongTrendGraph.vue?vue&type=script&lang=ts&"
import style0 from "./LongTrendGraph.vue?vue&type=style&index=0&id=512ddd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ddd6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VProgressCircular,VTooltip})
